import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-51cc93f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center flex-row-reverse navbar bg-white p-0 sticky z-50 top-0 left-0 shadow" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "m-1 mr-2 w-8 h-8 rounded-full bg-gray text-2xl cursor-pointer"
}
const _hoisted_4 = { class: "flex justify-center items-center h-full text-white cursor-pointer" }
const _hoisted_5 = {
  key: 2,
  class: "py-1 mt-2.5 bg-white absolute right-4 shadow card w-80"
}
const _hoisted_6 = { class: "py-2 text-gray cursor-pointer flex flex-col items-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "m-1 mr-2 w-12 h-12 rounded-full bg-gray text-2xl cursor-pointer"
}
const _hoisted_10 = { class: "flex justify-center items-center h-full text-white cursor-pointer" }
const _hoisted_11 = { class: "px-4 text-sm text-black font-semibold mt-2 capitalize" }
const _hoisted_12 = { class: "px-4 text-xs mt-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey w-full mt-2" }, null, -1))
const _hoisted_14 = {
  key: 2,
  class: "font-bold py-2.5"
}
const _hoisted_15 = {
  key: 3,
  class: "inline-block text-black font-semibold mt-2 text-sm"
}
const _hoisted_16 = { class: "flex items-center text-gray-normal text-xs px-4 mt-1 mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey w-full" }, null, -1))
const _hoisted_18 = { class: "flex justify-center items-center mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "menuIcon"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "absolute menucardContainer right-2 bg-white border p-3 flex justify-end flex-wrap gap-5 flex-row-reverse"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "h-full",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeApps && _ctx.closeApps(...args)))
      }),
      _createElementVNode("div", {
        class: "flex-none",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleUserDropdown && _ctx.toggleUserDropdown(...args)))
      }, [
        _createElementVNode("div", null, [
          (_ctx.userInfo.picture)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userInfo.picture,
                class: "rounded-full border border-lightgrey m-1 mr-4 w-8 h-8 cursor-pointer"
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getUserName()), 1)
              ])),
          (_ctx.showBlock)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.userInfo.picture)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _ctx.userInfo.picture,
                          class: "rounded-full m-1 mr-2 border border-lightgrey w-12 h-12 cursor-pointer"
                        }, null, 8, _hoisted_8)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getUserName()), 1)
                      ])),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.userInfo.email), 1),
                  _hoisted_13,
                  (_ctx.displayName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.displayName), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_15, "CrystallineSoft")),
                  _createElementVNode("div", _hoisted_16, " Session Expires In: " + _toDisplayString(_ctx.formattedRemainingTime), 1),
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "filterButton flex mt-1 logout",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                    }, " Log Out ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "relative pr-4 pl-2.5 inline-block",
      ref: "dropdownContainer",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMenuBlock=!_ctx.showMenuBlock))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["cursor-pointer rounded transition-colors duration-200 menubackgroundstyle", _ctx.showMenuBlock ? 'bg-[#adadad]' : 'hover:bg-lightgrey']),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
      }, _hoisted_20, 2),
      (_ctx.showMenuBlock )
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name,
                class: "menucard",
                onClick: ($event: any) => (_ctx.selectItem(item))
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: "icon",
                  class: "icon"
                }, null, 8, _hoisted_23),
                _createElementVNode("p", _hoisted_24, _toDisplayString(item.name), 1)
              ], 8, _hoisted_22))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}